export const COUPON_LOADING = 'REDUX_SAGA_COUPON_LOADING';
export const GET_COUPON_DATA_SUCCESS = 'REDUX_SAGA_GET_COUPON_DATA_SUCCESS';
export const GET_COUPON_DATA_ERROR = 'REDUX_SAGA_GET_COUPON_DATA_ERROR';
export const COUPON_END_LOADING = 'REDUX_SAGA_COUPON_END_LOADING';
export const RESET_COUPON = 'REDUX_SAGA_RESET_COUPON';


export const actionGetCoupon = (dispatch, coupnCode) => {
    dispatch({ type: COUPON_LOADING, coupnCode: coupnCode })
};

export const actionEndCouponLoading = (dispatch) => {
    dispatch({ type: COUPON_END_LOADING })
};

export const actionResetCoupon = (dispatch) => {
    dispatch({ type: RESET_COUPON })
}